<template>
    <div>
        <el-form :form="closeForm" :model="closeForm" :rules="closeRules" ref="closeForm" center>
            <el-form-item label="订单ID：">
                {{order.id}}
            </el-form-item>
            <el-form-item label="开通产品：">
                {{order.product_memo}}
            </el-form-item>
            <el-form-item label="所属客户：">
                {{order.customer_name}}
            </el-form-item>
            <el-form-item label="合同金额：">
                {{order.finance?order.finance.total_amount:0}}
            </el-form-item>
            <el-form-item label="订单状态：">
                <template>
                    <span>产品信息-{{getStatus(order.business_audit)}}；</span>
                    <span v-if="order.finance && !order.undo_finance">
                                <span>财务信息-{{getStatus(order.finance_audit)}}；</span>
                            </span>
                    <span v-if="order.contracts && order.contracts.length>0 && !order.undo_contract">
                                <span>合同附件-{{getStatus(order.contract_audit)}}；</span>
                            </span>
                </template>
            </el-form-item>
            <el-form-item label="关闭类型：" prop="close_type">
                <el-radio-group v-model="closeForm.close_type">
                    <el-radio :label="1">取消合作（已上传合同）</el-radio>
                    <el-radio :label="2">操作错误</el-radio>
                    <el-radio :label="4">取消合同（未上传合同）</el-radio>
                    <el-radio :label="3">其他</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="关闭原因：" prop="close_reason">
                <el-input type="textarea" v-model="closeForm.close_reason"></el-input>
            </el-form-item>
            <el-form-item label="附件：" prop="file_list">
                <el-upload class="upload-demo" name="contractFile"
                action="api/common/upload-contract"
                :headers="headers"
                :on-error="uploadError" :on-success="uploadSuccess"
                :on-preview="handlePreview"
                :on-remove="handleRemove" :file-list="closeForm.file_list"
                :beforeUpload="beforeUpload" list-type="text" multiple>
                    <el-button type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">上传pdf,docx,doc格式文档或JPG,JPEG,PNG图片,单个文件最大支持50MB,上传请耐心等待</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="申请人：">
                {{$store.getters.name}}
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取 消</el-button>
            <el-button type="primary" @click="doCloseOrder(order.type)">{{order.type==1?'确定':'提交审核'}}</el-button>
        </div>
    </div>
</template>

<script>
    import OrderService from "~/services/order";
    import Config from "~/config/params";

    export default {
        name: "closeForm",
        props: {
            order: {
                required: true,
                type: Object
            },
        },
        data() {
            return {
                close_type: [
                    {
                        value: "0",
                        label: '全部'
                    },
                    {
                        value: "1",
                        label: '取消合作',
                    }, {
                        value: "2",
                        label: '操作错误'
                    }, {
                        value: "4",
                        label: '取消合同'
                    },
                    {
                        value: "3",
                        label: '其他'
                    }
                ],
                closeForm: {
                    file_list: [],
                    close_type: '',
                    close_reason: '',//关闭原因
                },
                closeRules: {
                    'close_type': [
                        {required: true, message: '请选择关闭类型', trigger: 'blur'}
                    ],
                    'close_reason': [
                        {required: true, message: '请填写关闭原因', trigger: 'blur'}
                    ]
                },
                headers: {
                    "access-token": this.$store.getters.token
                },
            }
        },
        methods: {
            //关闭提交
            doCloseOrder(type) {
                this.$refs['closeForm'].validate((valid) => {
                    if (valid) {
                        let form = this.closeForm;
                        form['order_id'] = this.order.id;

                        if(type == 1){
                            OrderService.trialOrderClose(form).then(res => {
                                if (res.code == 0) {
                                    this.$message({
                                        type: 'success',
                                        message: this.order.type == 1 ? '关闭成功!' : '提交成功'
                                    });

                                    this.closeForm.close_type='';
                                    this.closeForm.close_reason='';
                                    this.closeDialog(true);
                                }
                            })
                        }else{
                            OrderService.close(form).then(res => {
                                if (res.code == 0) {
                                    this.$message({
                                        type: 'success',
                                        message: this.order.type == 1 ? '关闭成功!' : '提交成功'
                                    });
                                    this.closeForm.close_type='';
                                    this.closeForm.close_reason='';
                                    this.closeDialog(true);
                                }
                            })
                        }

                    }
                })
            },
            //获取状态
            getStatus(type) {
                if (type == Config.TYPE_CHECKED) {
                    return '已通过'
                }
                if (type == Config.TYPE_NO_CHECKED) {
                    return '待审核'
                }
                if (type == Config.TYPE_CHECKED_FAIL) {
                    return '未通过'
                }
                return '未填写'
            },
            closeDialog(submit){
                this.$emit('closeDialog',submit);
            },

            /** @description 合同附件*/
            handleRemove(file, fileList) {
                this.closeForm.file_list = fileList
            },

            handlePreview(file) {
                window.open(file.url);
            },

            uploadSuccess(response, file, fileList) {
                if (response.code > 0) {
                    this.$message({
                        message: response.msg,
                        type: 'error'
                    });
                    this.closeForm.file_list = this.closeForm.file_list.filter(function (item) {
                        return item.uid != file.uid;
                    });
                } else {
                    this.closeForm.file_list.push({
                        "name": response.data.file_name,
                        "url": response.data.file_path,
                        'id': response.data.id
                    });
                }
            },

            uploadError(err, file, fileList) {
                console.log('===');
            },

            beforeUpload(file) {
                let dot = file.name.lastIndexOf(".");
                let extension = file.name.substring(dot);
                let filesize = file.size / 1024 / 1024 > 50;
                let type = ['.pdf', '.docx', '.doc', '.jpg', '.jpeg', '.png', '.pem'];

                if (!type.includes(extension)) {
                    this.$message({
                        message: '上传格式不允许,只允许上传pdf,docx,doc,jpg,jpeg,png格式文件',
                        type: 'tips'
                    });
                    return false;
                }
                if (filesize) {
                    this.$message({
                        message: '上传文件大小不能超过50M',
                        type: 'error'
                    });
                    return false;
                }
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/closeForm.vue